import { Select as MuiSelect, Box, svgIconClasses, inputBaseClasses } from '@mui/material'
import FormGroup from '@mui/material/FormGroup'
import FormLabel from '@mui/material/FormLabel'
import { SelectProps as MuiSelectProps } from '@mui/material/Select'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export type C1SelectProps<T> = MuiSelectProps<T>

const C1SelectStyles: moduleStyleType = {
    label: {
        marginBottom: 1,
    },
    box: {
        [`& .${inputBaseClasses.root}`]: {
            minWidth: 120,
            height: 37,
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.default',
            '& fieldset': { border: 'none' },
            '&:hover': { borderColor: 'primary.main' },
            [`& .${svgIconClasses.root}`]: {
                maxWidth: '28px',
                color: 'text.secondary',
            },
        },
        [`& .${inputBaseClasses.focused}`]: {
            border: '1px solid',
            borderColor: 'primary.main',
            '& fieldset': { border: 'none' },
        },
    },
}

export const C1Select = <T, >({ ...props }: C1SelectProps<T>): React.ReactElement => {
    const finalProps = {
        variant: 'outlined' as const,
        ...props,
        label: '',
    }

    return (
        <FormGroup sx={{ width: props.fullWidth ? '100%' : 'auto' }}>
            {props.label && (
                <FormLabel sx={C1SelectStyles.label}>
                    {props.label}
                </FormLabel>
            )}
            <Box sx={C1SelectStyles.box}>
                <MuiSelect displayEmpty {...finalProps} />
            </Box>
        </FormGroup>
    )
}
